import { NgModule, ModuleWithProviders } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { PuiElementsModule } from '../elements/elements.module';

// components
import { PuiLoginComponent } from './login/login.component';
import { PuiLogoutComponent } from './logout/logout.component';
import { PuiWelcomeComponent } from './welcome/welcome.component';
import { PuiPageNotFoundComponent } from './not-found/not-found.component';
import { PuiCallbackComponent } from './auth-callback/callback.component';
import { PuiUserProfileComponent } from './user-profile/user-profile.component';

const PAGES_COMPONENTS = [
  PuiWelcomeComponent,
  PuiPageNotFoundComponent,
  PuiCallbackComponent,
  PuiLoginComponent,
  PuiLogoutComponent,
  PuiUserProfileComponent
];

@NgModule({
  declarations: PAGES_COMPONENTS,
  imports: [
    PuiElementsModule,
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  exports: PAGES_COMPONENTS,
})
export class PuiPagesModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: PuiPagesModule, providers: [] };
  }
}
